import React, { ComponentProps, useState } from 'react';
import { TextInput } from '@tcc/crate';

interface FocustInput extends Partial<ComponentProps<typeof TextInput>> {
  value: string;
  displayValue: string;
}

export const FocusInput = ({ value, displayValue, onBlur, onFocus, ...props }: FocustInput) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <TextInput
      {...(props as ComponentProps<typeof TextInput>)}
      onBlur={(e) => {
        setIsFocused(false);
        onBlur?.(e);
      }}
      onFocus={(e) => {
        setIsFocused(true);
        onFocus?.(e);
      }}
      value={isFocused ? value : displayValue}
    />
  );
};
